export const ITINERARY = {
    tab: 'trip-tab-itinerary',
    container: 'itinerary-container',
    emptyState: 'itinerary-empty',
    generateButton: 'itinerary-generate-button',
    regenerateButton: 'itinerary-regenerate-button',
    specialRequestsInput: 'itinerary-special-requests-input',
    emphasisSelect: 'itinerary-emphasis-select',
    consensusScore: 'itinerary-consensus-score',
    perPersonRow: 'itinerary-per-person-row',
    leastSatisfiedCallout: 'itinerary-least-satisfied',
    personalityBalance: 'itinerary-personality-balance',
    conflictResolutionsToggle: 'itinerary-conflict-resolutions-toggle',
    conflictResolutionItem: 'itinerary-conflict-resolution-item',
    dayBlock: 'itinerary-day-block',
    activityCard: 'itinerary-activity-card',
    activityDragHandle: 'itinerary-activity-drag-handle',
    activityTime: 'itinerary-activity-time',
    activityDuration: 'itinerary-activity-duration',
    activityMapsLink: 'itinerary-activity-maps-link',
    activityMoveToTrigger: 'itinerary-activity-move-to-trigger',
    activityMoveToOption: 'itinerary-activity-move-to-option',
    dayTabsContainer: 'itinerary-day-tabs',
    dayTab: 'itinerary-day-tab',
    dayTabAll: 'itinerary-day-tab-all',
    exportPdfButton: 'itinerary-export-pdf-button',
    generationCount: 'itinerary-generation-count',
    loadingState: 'itinerary-loading',
    // Fix 2 — manual editing
    addActivityButton: 'itinerary-add-activity-button',
    addActivityBetween: 'itinerary-add-activity-between',
    activityEditButton: 'itinerary-activity-edit-button',
    activityDeleteButton: 'itinerary-activity-delete-button',
    activityEditorSheet: 'itinerary-activity-editor',
    editorFieldTime: 'itinerary-activity-editor-time',
    editorFieldLocation: 'itinerary-activity-editor-location',
    editorFieldDuration: 'itinerary-activity-editor-duration',
    editorFieldCategory: 'itinerary-activity-editor-category',
    editorFieldDescription: 'itinerary-activity-editor-description',
    editorFieldNote: 'itinerary-activity-editor-note',
    editorSaveButton: 'itinerary-activity-editor-save',
    editorCancelButton: 'itinerary-activity-editor-cancel',
    activityNoteBadge: 'itinerary-activity-note-badge',
    activityNoteToggle: 'itinerary-activity-note-toggle',
    activityNoteTextarea: 'itinerary-activity-note-textarea',
    activityNoteSave: 'itinerary-activity-note-save',
    activityNoteCancel: 'itinerary-activity-note-cancel',
};
